export { default as VideoControls } from "./video-controls";
